import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { EspacioCurricularI } from "interfaces/EspacioCurricular";
import { Dropdown } from "react-bootstrap";
import { deleteEspacioCurricular } from "services/espacioCurricular";

interface Props {
  elemento: EspacioCurricularI;
  onClickEdit: (elemento: EspacioCurricularI) => void;
  onClickShowDetail: (elemento: EspacioCurricularI) => void;
  refreshTable: () => void;
}

export const EspaciosCurricularesRowActions = ({
  elemento,
  onClickEdit,
  onClickShowDetail,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteEspacioCurricular(id);
      showSuccessToast("¡El espacio curricular fue eliminado con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando el espacio curricular: ", error.message);
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickShowDetail(elemento)}>
          Ver detalle
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar espacio curricular"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el espacio curricular {elemento.descripcion}{" "}
              <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
